import { createContext, useContext, useState } from 'react'

export const CarContext = createContext({ value: {} })

export const useCarContext = () => useContext(CarContext)

export default function CarContextProvider({ children }) {
  const [techState, setTechState] = useState()
  const [car, setCar] = useState()

  return (
    <CarContext.Provider value={{ techState, setTechState, car, setCar }}>
      {children}
    </CarContext.Provider>
  )
}
